import React from 'react'
import AmbulatoryCategoriesLayout from 'presentation/doctor/layouts/AmbulatoryCategories'

function AmbulatoryCategories() {
  return <AmbulatoryCategoriesLayout />
}

export default AmbulatoryCategories
